import {
  ActionType,
  IFullStressLastNotificationTimeResponse,
} from "models/stressCheck/fullStressLastNotificationTime";

export const getFullStressLastNotificationTimeAction = () => {
  return {
    type: ActionType.FULL_STRESS_LAST_NOTIFICATION_TIME,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.FULL_STRESS_LAST_NOTIFICATION_TIME_ERROR,
    payload,
  };
};

export const handleSuccesAction = (
  payload: IFullStressLastNotificationTimeResponse
) => {
  return {
    type: ActionType.FULL_STRESS_LAST_NOTIFICATION_TIME_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.FULL_STRESS_LAST_NOTIFICATION_TIME_RESET,
  };
};
